import React, { useEffect, useState } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Button } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import axios from 'axios'
import { environment } from "../../environment";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Swal from 'sweetalert2';
import { type } from 'os';

const { SearchBar } = Search;


const MyTickets = (history) => {

    const [data, setData] = useState([])
    let userDetails = localStorage.getItem("userDetails");
    userDetails = JSON.parse(userDetails);

    useEffect(() => {
        axios.post(environment.dap_url + "support/getTicketByCustomer",{email:userDetails.data.email}).then((response) => {
            console.log(response.data);
            const temp = [];
            // response.data.map((item, index) => {
            //     const date = item.createdAt.split("T")[0];
            //     temp.push({
            //         id: index + 1,
            //         date: date,
            //         ticketId: item.ticketId,
            //         name: item.customerName,
            //         priority: item.priority,
            //         assignedTo: item.assignedTo.executive_details[0].userFirstName+" "+item.assignedTo.executive_details[0].userLastName,
            //         status: item.status,
            //         action: actions(item.ticketId),
            //     })
            // }
            // )
            // setData(...data, temp);
            setData(response.data)
        }).catch((error) => {
            console.log(error);
        })

    }, [])

    const defaultSorted = [
        {
          dataField: "id",
          order: "desc",
        },
      ];

    const deleteTicket = (id) => {
        Swal.fire({
            title:"Are you sure?",
            icon:"warning",
            showConfirmButton:true,
            showCancelButton:true
        }).then(result=>{
            if(result.isConfirmed){
                axios.delete(environment.dap_url+"support/delete?id="+id).then(res=>{
                    if(res){
                        Swal.fire({
                            icon: 'success',
                            title: 'Ticket Deleted',
                            showConfirmButton: false,
                            timer: 1500
                        }).then(result=>{
                            // handleCancel();
                            // history.push("/supports");
                            window.location.reload();
                        })
                    }
                })
            }
        })
    }  


    const actions = (ticketId) => {
        return (
            <>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div>
                        <LinkContainer
                            to={`/supports/ticket/edit/?ticketid=${ticketId}`}
                            style={{

                                background: "#FFDD33",
                                color: "white",
                                radius: "50px",
                            }}
                        >
                            <Button variant="light" className="btn-sm">
                                <span class="typcn typcn-edit"></span>
                            </Button>
                        </LinkContainer>
                    </div>
                    <div>
                        <LinkContainer
                            to={`/supports/ticket/view/?ticketid=${ticketId}`}
                            style={{

                                background: "blue",
                                color: "white",
                                radius: "50px",
                            }}
                        >
                            <Button variant="light" className="btn-sm">
                                <span class="typcn typcn-eye-outline"></span>
                            </Button>
                        </LinkContainer>
                    </div>
                    <div>
                        <LinkContainer
                            to={`/supports/ticket/delete/?ticketid=${ticketId}`}
                            style={{

                                background: "red",
                                color: "white",
                                radius: "50px",
                            }}
                        >
                            <Button variant="light" className="btn-sm">
                                <span class="typcn typcn-trash"></span>
                            </Button>
                        </LinkContainer>
                    </div>
                </div>
            </>
        )
    }

    const columns = [{
        dataField: 'id',
        text: '#',
        formatter:(row,col,rowIndex,formatExtra)=>{
            return (rowIndex+1)
        }
    }, {
        dataField: 'createdAt',
        text: 'Date',
        formatter:(dataField)=>{
            return (dataField.split("T")[0])
        }
    }, {
        dataField: 'ticketId',
        text: 'Ticket Id'
    }, 
    // {
    //     dataField: 'customer_details[0]',
    //     text: 'Customer Name',
    //     formatter:(dataField)=>{
    //         return (dataField.userFirstName+" "+dataField.userLastName)
    //     }
    // },
     {
        dataField: 'description',
        text: 'Description'
    }, {
        dataField: 'executive_details',
        text: 'Assigned To',
        formatter:(row,col,rowIndex,formatter)=>{
            console.log("tic",col.executive_details.length)
            if(col.executive_details.length>0){
                return (col.executive_details[0].userFirstName+" "+col.executive_details[0].userLastName);
            }else{
                return ""
            }
        }
    }, {
        dataField: 'status',
        text: 'Status',
        formatter:(dataField)=>{
            if(dataField == "close"){
                return "Closed"
            }
            return dataField
        }
    },
    
    //To be open later

    {
        dataField: '_id',
        text: 'Action',
        formatter:(dataField)=>{
            return (
                <div style={{ display: "flex", flexDirection: "row" }}>
                {/* <div>
                    <LinkContainer
                        to={`/supports/editTicket/`+dataField}
                        style={{

                            background: "#FFDD33",
                            color: "white",
                            radius: "50px",
                        }}
                    >
                        <Button variant="light" className="btn-sm">
                            <span class="typcn typcn-edit"></span>
                        </Button>
                    </LinkContainer>
                </div> */}
                <div>
                    <LinkContainer
                        to={`/my-supports/ViewTicket/`+dataField}
                        style={{

                            background: "blue",
                            color: "white",
                            radius: "50px",
                        }}
                    >
                        <Button variant="light" className="btn-sm">
                            <span class="typcn typcn-eye-outline"></span> View
                        </Button>
                    </LinkContainer>
                </div>
                {/* <div>
                    
                        <Button variant="light" className="btn-sm" onClick={e=>{deleteTicket(dataField)}}>
                            <span class="typcn typcn-trash"></span>
                        </Button>
                </div> */}
                </div>)
        }
    }
    ];




    return (
        <div className='card p-4 mt-2'>
            <div className="row" style={{ marginTop: "72px" }}>
                <div className="col-lg-11">
                    <LinkContainer
                        to={`/createTickets`}
                        style={{
                            float: "right",

                            background: "#5271FF",
                            marginBottom: "20px",
                            color: "white",
                            radius: "8px",
                        }}
                    >
                        <Button variant="light" className="btn-lg">
                            New Ticket
                        </Button>
                    </LinkContainer>
                </div>

            </div>
            <div className="row">
                <h3 className="card-title" style={{ paddingLeft: "39px" }}>
                    TICKETS
                </h3>
            </div>
            <div style={{ marginLeft: "4%", marginRight: "4%" }}>
                <div className='row'>
                    <div className="col-12">
                    <ToolkitProvider
                      keyField="id"
                      bootstrap4
                      data={data}
                      columns={columns}
                      search
                    >
                        {(props)=>(
                            <div>
                                <div className="d-flex align-items-center">
                                    <p className="mb-2 mr-2">Search in table:</p>
                                    <SearchBar {...props.searchProps} />
                                </div>
                                <BootstrapTable
                                    defaultSorted={defaultSorted}
                                    pagination={paginationFactory()}
                                    {...props.baseProps}
                                    wrapperClasses="table-responsive"
                                />
                            </div>
                            
                        )}
                    </ToolkitProvider>
                        {/* <BootstrapTable keyField='id' data={data} columns={columns} /> */}

                    </div>

                </div>
            </div>

        </div>
    )


}

export default MyTickets